import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { insuranceType } from "../../store/insuranceType/actions";
export var useInsuranceTypeGetAll = function (trigger, clientId, namesearch, insuranceTypePage, insuranceTypeLimit) {
    var dispatch = useDispatch();
    var enable = useState(true)[0];
    var _a = useSelector(function (state) { return ({
        responseInsuranceType: state.InsuranceType.responseInsuranceType,
        errorInsuranceType: state.InsuranceType.errorInsuranceType,
        loadingInsuranceType: state.InsuranceType.loadingInsuranceType,
    }); }), responseInsuranceType = _a.responseInsuranceType, errorInsuranceType = _a.errorInsuranceType, loadingInsuranceType = _a.loadingInsuranceType;
    useEffect(function () {
        if (trigger) {
            dispatch(insuranceType({
                enable: enable,
                page: insuranceTypePage,
                limit: insuranceTypeLimit,
                clientId: clientId,
                description: namesearch,
            }));
        }
    }, [trigger]);
    return {
        responseInsuranceType: responseInsuranceType,
        errorInsuranceType: errorInsuranceType,
        loadingInsuranceType: loadingInsuranceType,
    };
};
